import * as Text from './hds'
import * as TextPlus from './hdsplus'

export default Text
export { TextPlus }
